import React from 'react';
import moment from "moment";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

export default class OrgCourses extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            loaded: false,
            error: false,
            isOrgAdmin: false,
            courses: []
        }
    }
    componentDidMount()
    {
        this.loadMyCourses();
    }
    loadMyCourses()
    {
        this.props.api.send({
            controller: "Course",
            action: "LoadOrganizationCourses",
            method: "get",
            success: (response) => {
                response.success ?
                    this.setState({loaded: true, courses: response.courses, isOrgAdmin: response.isOrgAdmin}) :
                    this.setState({loaded: true, error: true})
            },
            error: (err) => {
                this.setState({loaded: true, error: true})
            }
        })
    }
    startEditDueDate(e, cidx){
        let courses = this.state.courses;
        let course = courses[cidx];
        course["isEditingDate"] = true
        course["tempEditDate"] = course.dueDate;
        this.setState({courses:courses});
    }
    editDueDate(e, cidx){
        let courses = this.state.courses;
        let course = courses[cidx];
        if(e === null)
            course.dueDate = null
        else
            course.dueDate = e._d.toString()
        this.setState({courses:courses});
    }
    confirmEditDueDate(e, cidx){
        let courses = this.state.courses;
        let course = courses[cidx];
        course["isEditingDate"] = false
        this.setState({courses:courses});
        var payload = JSON.parse(JSON.stringify(course))
        payload.dueDate = payload.dueDate !== null ? moment(payload.dueDate).format("YYYY-MM-DD HH:mm:ss") : null;
        this.props.api.send({
            controller: "Course",
            action: "SetDueDate",
            method: "post",
            body: JSON.stringify(payload),
            success: (response) => {
               
            },
            error: (err) => {
                this.setState({loaded: true, error: true})
            }
        })
    }
    cancelEditDueDate(e, cidx){
        let courses = this.state.courses;
        let course = courses[cidx];
        course["isEditingDate"] = false
        course.dueDate= course.tempEditDate;
        this.setState({courses:courses});
    }

    render()
    {
        let isOrgAdmin = this.state.isOrgAdmin;
        const courselist = this.state.courses.map((c, cidx) => 
            <tr key={c.cidx}>
                <td>{c.courseName}</td>
                <td>{c.courseDescription}</td>
                <td style={{width: "10%", whiteSpace: "nowrap"}}>
                    {isOrgAdmin === true ? 
                        <div>
                            {!("isEditingDate" in c) || c.isEditingDate === false ? 
                            <div>
                                {c.dueDate !== null ? moment(c.dueDate).format("YYYY-MM-DD HH:mm:ss") : ""}
                                <a className="lmsbutton" href="/" onClick={(e) => { 
                                    e.preventDefault(); this.startEditDueDate(e, cidx)
                                }}>{c.dueDate === null ? "Set" : "Change"}</a>
                            </div>
                            : c.isEditingDate === true ? 
                                <div>
                                    <DatePicker showTimeSelect name={this.props.name}
                                        className="lmsforminput"
                                        timeFormat="HH:mm" dateFormat="MM/DD/YYYY HH:mm"
                                        id={c.courseID.toString()} 
                                        timeIntervals={5}
                                        selectsStart
                                        selected={c.dueDate !== null? moment(c.dueDate) : null}
                                        startDate={c.dueDate !== null? moment(c.dueDate) : null}
                                        onChange={(e, index, itemType) => this.editDueDate(e, cidx)} 
                                    />
                                    <a className="lmsbutton" href="/" onClick={(e) => {
                                        e.preventDefault(); this.confirmEditDueDate(e, cidx)
                                    }}>Confirm</a>
                                    <a className="lmsbutton" href="/" onClick={(e) => {
                                        e.preventDefault(); this.cancelEditDueDate(e, cidx)
                                    }}>Cancel</a>
                                </div>
                                :
                                <div>
                                    {c.dueDate !== null ? moment(c.dueDate).format("YYYY-MM-DD HH:mm:ss") : ""}
                                </div>
                                
                            }
                        </div>
                    : 
                        <div>
                            {c.dueDate !== null ? moment(c.dueDate).format("YYYY-MM-DD HH:mm:ss") : ""}
                        </div>
                    }
                </td>
            </tr>
        )
        return (
            <div style={{marginTop: "10px"}}>
                <strong>Courses</strong>
                {this.state.loaded ?
                    this.state.courses.length > 0 ? (
                        <div >
                            <table className="lmstable">
                                <tbody>
                                    <tr>
                                        <th>Name</th>
                                        <th>Description</th>
                                        <th>Due Date</th>
                                    </tr>
                                    {courselist}
                                </tbody>
                            </table>                            
                        </div>
                    ) : (
                    <p>
                        <i>You do not currently have any courses available. Check the Course Catalog for available courses.</i>
                    </p>
                ) : (
                    <div className="lmscenter"><img src="/images/spinner.svg" alt="Loading..." /></div>
                )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/organization/orgcourses.js